import { CreateTicketDTO } from '../models/DashboardTicket'
import { TicketRepository } from '../repositories/TicketRepository'

export function CreateTicketCase(ticketRepository: TicketRepository) {
  return async function (data: CreateTicketDTO) {
    return await ticketRepository.createTicket(data)
  }
}
